import React, { useState, forwardRef, useEffect, useLayoutEffect } from 'react';
import moment from 'moment';
import NextArrow from '../../images/priva-nav-right.png';
import PrevArrow from '../../images/priva-nav-left.png';
import PostFooter from './post-footer';
import PVideo from '../PVideo';
import { CARD_ERRORS, ORIENTATION, POST_STATUS, ROLES, s3Link } from '../../utils/constants';
import Avatar from '../Avatar';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Pinned from '../../images/pin-blue.png';
import Duration from '../Duration';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from "swiper";
import LockIcon from '../../images/silver-app.png';
import PriceText from '../PriceText';
import CountDownTimer from '../CountDownTimer';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import '../jquery';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import './style.scss';
import './mobile-style.scss';
import './fancybox-styles.scss';
import './carousel-style.scss';
import './overrides.scss';

import fancybox from "@fancyapps/fancybox";
import '@fancyapps/fancybox/src/css/core.css';
import { isMobile } from 'react-device-detect';
import { connect, useDispatch } from 'react-redux';
import currency from 'currency.js';
import { showImageCounter, showPrice, showVideoCounter } from '../../utils/helper';
import PostActions from './pu-post-actions';
import SilverLockIcon from '../../images/silver-app.png';
import UnlockPurchaseButton from './unlock-purchase-button';
import SuPostActions from "./su-post-actions";
import Thumbprint from "../Thumbprint";
import { setPost } from '../../../redux/actions/post';
import { CircularProgress } from '@mui/material';

const checkAspectRatio = (ratio) => {
    if (parseFloat(ratio) >= .58 && parseFloat(ratio) < .90) {
        return (' p_3_4');
    } else if (parseFloat(ratio) >= .42 && parseFloat(ratio) <= .57) {
        return (' p_9_16');
    } else if (parseFloat(ratio) <= .41) {
        return (' p_9_22');
    } else if (parseFloat(ratio) == 1) {
        return (' p_1_1');
    } else if (parseFloat(ratio) == 1.33) {
        return (' l_3_4');
    } else if (parseFloat(ratio) >= 1.34 && parseFloat(ratio) <= 2.43) {
        return (' l_9_16');
    } else if (parseFloat(ratio) >= 2.44) {
        return (' l_9_22');
    } else {
        return (' p_1_1');
    }
};

const SampleNextArrow = React.memo((props) => {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "block" }}
            onClick={onClick}>
            <img src={NextArrow} className="action" />
        </div>
    );
});

const SamplePrevArrow = React.memo((props) => {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "block" }}
            onClick={onClick}>
            <img src={PrevArrow} className="action" />
        </div>
    );
});


const PostItem = forwardRef(({
    posts,
    post,
    pu, //pu from server not from localhost
    refetch,
    setRefetch,
    setActiveComment,
    autoplay = false,
    activePost,
    handleShow,
}, ref) => {
    const [comment, setComment] = useState(false);
    const [shortCaption, setShortCaption] = useState('');
    const [hasPortrait, setHasPortrait] = useState(false);
    const [hasEqual, setHasEqual] = useState(false);
    const [hasLandscape, setHasLandscape] = useState(false);
    const [width, setWidth] = useState(1080);
    const [height, setHeight] = useState(2640);
    const [currentCategories, setCurrentCategories] = useState(post.categories || []);
    const [categoryEditMode, setCategoryEditMode] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const [containerAspectRatio, setContainerAspectRatio] = useState('');
    const [currentPost, setCurrentPost] = useState(post);
    const [isDiscounted, setIsDiscounted] = useState(false);

    const userInformation = JSON.parse(localStorage.getItem('user'));

    const dispatch = useDispatch();

    useLayoutEffect(() => {
        $.fancybox.defaults.hash = false;
        $.fancybox.defaults.protected = true;
        $.fancybox.defaults.loop = true;
        $.fancybox.defaults.slideShow = false;
        $.fancybox.defaults.smallBtn = false;
        $.fancybox.defaults.idleTime = false;
        $.fancybox.defaults.hideScrollbar = true;
        $.fancybox.defaults.closeExisting = false;
        $.fancybox.defaults.mobile = {
            clickSlide: 'close'
        };
        $.fancybox.defaults.touch = {
            vertical: false
        },
            $.fancybox.defaults.clickContent = (current, event) => current.type === 'image' ? 'zoom' : false;
        setHeight(window.screen.height);
        setWidth(window.screen.width);
    }, []);

    const [numImages, setNumImages] = useState(0);
    const [numVideos, setNumVideos] = useState(0);
    useEffect(() => {
        setCurrentCategories(post.categories);

        let imagesTotal = 0;
        let videosTotal = 0;

        post.medias && post.medias.forEach(media => {
            if (media.type.toLowerCase() === 'video') {
                videosTotal += 1;
            }

            if (media.type.toLowerCase() === 'image') {
                imagesTotal += 1;
            }
        });

        setNumVideos(videosTotal);
        setNumImages(imagesTotal);

        if (post.promo_price > 0 && post.expire_at) {
            const expiry = moment.utc(post.expire_at).local();
            if (moment().isSameOrAfter(expiry, 'seconds')) {
                setIsDiscounted(false);
            } else {
                setIsDiscounted(true);
            }
        }
    }, [post]);

    useEffect(() => {
        const onMessageFromFooter = () => {
            setCategoryEditMode(true);
        };
        window.addEventListener('footer/add-to-album/' + post.id, onMessageFromFooter);

        return () => {
            window.removeEventListener('footer/add-to-album/' + post.id, onMessageFromFooter);
        };
    }, []);

    useEffect(() => {
        const onCategoryChanged = ({ detail }) => {
            if (categoryEditMode === true) {
                setCurrentCategories(detail);
            }
        };

        const onHideCategoryModal = () => {
            // on cancel
            setTimeout(() => {
                setCurrentCategories(post.categories);
                setCategoryEditMode(false);
            }, 10);
        };

        const onConfirmCategoryModal = () => {
            setCategoryEditMode(false);
        };


        if (categoryEditMode === true) {
            window.addEventListener('wall-album/checkchange', onCategoryChanged);
            window.addEventListener('category-modal/hide', onHideCategoryModal);
            window.addEventListener('category-modal/confirm', onConfirmCategoryModal);
        } else {
            window.removeEventListener('wall-album/checkchange', onCategoryChanged);
            window.removeEventListener('category-modal/hide', onHideCategoryModal);
            window.removeEventListener('category-modal/confirm', onConfirmCategoryModal);
        }

        return () => {
            window.removeEventListener('wall-album/checkchange', onCategoryChanged);
            window.removeEventListener('category-modal/hide', onHideCategoryModal);
            window.removeEventListener('category-modal/confirm', onConfirmCategoryModal);
        };
    }, [categoryEditMode]);

    const Caption = ({ post }) => {
        const [showMore, setShowMore] = useState(false);

        useEffect(() => {
            if (post.caption && post.caption.split(" ").length > maxWords) {
                setShortCaption(truncate(post.caption, maxWords));
            }
        }, [post]);

        const toggleShowCaption = e => {
            e.preventDefault();
            setShowMore(showMore => !showMore);
        };

        const truncate = (str, no_words) => {
            return str.split(" ").splice(0, no_words).join(" ");
        };

        const maxWords = 45;

        if (shortCaption && !showMore) {
            return <React.Fragment>
                <div style={{ display: 'inline' }} dangerouslySetInnerHTML={{ __html: shortCaption }} />... <a href="#" onClick={toggleShowCaption}>See more</a>
            </React.Fragment>;
        } else if (shortCaption && showMore) {
            return <React.Fragment><div style={{ display: 'inline' }} dangerouslySetInnerHTML={{ __html: post.caption }} /> <a href="#" onClick={toggleShowCaption}>See less</a>
            </React.Fragment>;
        } else {
            return <React.Fragment><div style={{ display: 'inline' }} dangerouslySetInnerHTML={{ __html: post.caption }} />
            </React.Fragment>;
        }
    };

    useEffect(() => {
        if (post.medias && post.medias.length > 0) {
            const portraits = post.medias.filter(media => {
                return media.orientation == ORIENTATION.PORTRAIT;
            });

            setHasPortrait(hasPortrait => portraits.length > 0);

            const equal = post.medias.filter(media => {
                return media.orientation == ORIENTATION.EQUAL;
            });

            setHasEqual(hasEqual => equal.length > 0);

            const landscape = post.medias.filter(media => {
                return media.orientation == ORIENTATION.LANDSCAPE;
            });

            setHasLandscape(hasLandscape => landscape.length > 0);

            // check if post is paid
            let aspectRatios = [];

            if (parseFloat(post.price) > 0 && !post.unlocked) {
                aspectRatios = [checkAspectRatio(post.medias[0].aspect_ratio)];
            } else {
                aspectRatios = post.medias.map(media => checkAspectRatio(media.aspect_ratio));
            }

            if (aspectRatios.includes(' l_3_4')) {
                setContainerAspectRatio(' l_3_4');
            }

            if (aspectRatios.includes(' l_9_16')) {
                setContainerAspectRatio(' l_9_16');
            }

            if (aspectRatios.includes(' l_9_22')) {
                setContainerAspectRatio(' l_9_22');
            }

            if (aspectRatios.includes(' p_1_1')) {
                setContainerAspectRatio(' p_1_1');
            }

            if (aspectRatios.includes(' p_3_4')) {
                setContainerAspectRatio(' p_3_4');
            }

            if (aspectRatios.includes(' p_9_16')) {
                setContainerAspectRatio(' p_9_16');
            }

            if (aspectRatios.includes(' p_9_22')) {
                setContainerAspectRatio(' p_9_22');
            }
        }
    }, [post]);

    if (post && Object.keys(post).length <= 0) {
        return <CircularProgress />;
    }

    return (
        <div
            ref={ref}
            className={`
                shop-item
                ${!post.unlocked && post.medias.length > 1 && !post.has_free_preview
                    ? ' media-item__bundle'
                    : ''
                }`
            }
            key={post.id}
        >
            <div className="shop-media-container" onClick={() => handleShow(post)}>
                <LazyLoadImage
                    src={
                        post.unlocked ? `${s3Link}/${post.medias[0]?.thumb_path}`
                            : (
                                post.medias.length > 1 // bundle
                                    ? (
                                        post.has_free_preview
                                            ? `${s3Link}/${post.medias[0]?.thumb_path}`
                                            : `${SilverLockIcon}`
                                    )
                                    : `${s3Link}/${post.medias[0]?.blurred_path}`
                            )
                    }
                    effect="blur"
                    className={`
                            ${!post.unlocked && post.medias.length > 1 && !post.has_free_preview
                            ? 'img-gallery__bundle'
                            : 'img-fluid'
                        }
                        `}
                    onContextMenu={e => e.preventDefault()}
                    nosave="true"
                />
                {
                    post.has_free_preview &&
                    <span className="post__free-preview-label">Free Preview</span>
                }
            </div>


            <div className="shop-item-caption">{post.caption}</div>

            <div className='post-list-item__stats shop-item-price'>
                {
                    post.price > 0 && (userInformation.role === ROLES.PU || !post.unlocked)
                    && (
                        isDiscounted
                            ? <div className='post-list-item__price'>Price: <PriceText price={post.price} discountedPrice={post.promo_price} isDiscounted /></div>
                            : <div className='post-list-item__price'>Price: <PriceText price={post.price} /></div>
                    )
                }

                {
                    post.price > 0 && (userInformation.role === ROLES.PU || !post.unlocked) && (numImages > 0 || numVideos > 0) && <i className="fa-solid fa-circle"></i>
                }

                {showImageCounter(numImages)}
                {showVideoCounter(numVideos)}
            </div>
        </div>
    );
});

const mapStateToProps = (state) => {
    return {
        activePost: state.post.selectedPost
    };
};


export default React.memo(connect(mapStateToProps, null, null, { forwardRef: true })(PostItem));

